/**
 * Socket.io Client for Real-time Notifications and Updates
 */

import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://api.fly8.com';

let socket = null;

export const initSocket = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.warn('No token found, cannot connect to socket');
    return null;
  }

  if (socket && socket.connected) {
    return socket;
  }

  socket = io(SOCKET_URL, {
    auth: {
      token
    },
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000
  });

  socket.on('connect', () => {
    console.log('Socket connected');
  });

  socket.on('disconnect', () => {
    console.log('Socket disconnected');
  });

  socket.on('connect_error', (error) => {
    console.error('Socket connection error:', error);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export const getSocket = () => socket;

// Notification events
export const onNotification = (callback) => {
  if (socket) {
    socket.on('notification', callback);
  }
};

export const offNotification = () => {
  if (socket) {
    socket.off('notification');
  }
};

// Service Request events
export const onServiceRequestUpdated = (callback) => {
  if (socket) {
    socket.on('service_request_updated', callback);
  }
};

export const offServiceRequestUpdated = () => {
  if (socket) {
    socket.off('service_request_updated');
  }
};

// Task events
export const onTaskCreated = (callback) => {
  if (socket) {
    socket.on('task_created', callback);
  }
};

export const offTaskCreated = () => {
  if (socket) {
    socket.off('task_created');
  }
};

export const onTaskUpdated = (callback) => {
  if (socket) {
    socket.on('task_updated', callback);
  }
};

export const offTaskUpdated = () => {
  if (socket) {
    socket.off('task_updated');
  }
};

// Join/leave rooms for specific resources
export const joinServiceRequestRoom = (serviceRequestId) => {
  if (socket) {
    socket.emit('join_service_request_room', serviceRequestId);
  }
};

export const leaveServiceRequestRoom = (serviceRequestId) => {
  if (socket) {
    socket.emit('leave_service_request_room', serviceRequestId);
  }
};

// ============================================
// CHAT EVENTS
// ============================================

// Join/leave chat room
export const joinChatRoom = (serviceRequestId) => {
  if (socket) {
    socket.emit('join_chat_room', serviceRequestId);
  }
};

export const leaveChatRoom = (serviceRequestId) => {
  if (socket) {
    socket.emit('leave_chat_room', serviceRequestId);
  }
};

// New chat message listener
export const onNewChatMessage = (callback) => {
  if (socket) {
    socket.on('new_chat_message', callback);
  }
};

export const offNewChatMessage = () => {
  if (socket) {
    socket.off('new_chat_message');
  }
};

// Typing indicators
export const onUserTyping = (callback) => {
  if (socket) {
    socket.on('user_typing', callback);
  }
};

export const offUserTyping = () => {
  if (socket) {
    socket.off('user_typing');
  }
};

export const emitTypingStart = (serviceRequestId) => {
  if (socket) {
    socket.emit('typing_start', { serviceRequestId });
  }
};

export const emitTypingStop = (serviceRequestId) => {
  if (socket) {
    socket.emit('typing_stop', { serviceRequestId });
  }
};

export default {
  initSocket,
  disconnectSocket,
  getSocket,
  onNotification,
  offNotification,
  onServiceRequestUpdated,
  offServiceRequestUpdated,
  onTaskCreated,
  offTaskCreated,
  onTaskUpdated,
  offTaskUpdated,
  joinServiceRequestRoom,
  leaveServiceRequestRoom,
  // Chat exports
  joinChatRoom,
  leaveChatRoom,
  onNewChatMessage,
  offNewChatMessage,
  onUserTyping,
  offUserTyping,
  emitTypingStart,
  emitTypingStop
};
